import * as React from 'react';
import FlagInput from '../inputs/FlagInput';
import { IFormInputProps } from '../interfaces/IFormInputProps';

export const NumberFlagInput = (props: IFormInputProps<number> & { onText?: string, offText?: string }) =>
    <FlagInput {...props}
        value={props.value == 1}
        onEditComplete={(value) => { props.onEditComplete && props.onEditComplete(value! ? 1 : 0) }}
        onChanged={(value) => { props.onChanged && props.onChanged(value ? 1 : 0) }} />